export const summaryValues = {
  AVERAGE_DAYS_AWAITING_REVIEW: 'AVERAGE_DAYS_AWAITING_REVIEW',
  AVERAGE_DAYS_IN_REVIEW: 'AVERAGE_DAYS_IN_REVIEW',
  AVERAGE_DAYS_PRE_SCREENING: 'AVERAGE_DAYS_PRE_SCREENING',
  AVERAGE_MONTHLY_ENROLLMENT: 'AVERAGE_MONTHLY_ENROLLMENT',
  CURRENT_DURATION: 'CURRENT_DURATION',
  ENROLLMENT_DIFFERENCE: 'ENROLLMENT_DIFFERENCE',
  HAS_ACTIVE_PRACTICE: 'HAS_ACTIVE_PRACTICE',
  HAS_FEASIBILITY_PRACTICE: 'HAS_FEASIBILITY_PRACTICE',
  OVERALL_PARENT_TRIAL_ID: 'OVERALL_PARENT_TRIAL_ID',
  MONTHLY_ENROLLMENT_DIFFERENCE: 'MONTHLY_ENROLLMENT_DIFFERENCE',
  PATIENT_AWAITING_REVIEW_COUNT: 'PATIENT_AWAITING_REVIEW_COUNT',
  PATIENT_COMPLETED_COUNT: 'PATIENT_COMPLETED_COUNT',
  PATIENT_FOLLOWING_COUNT: 'PATIENT_FOLLOWING_COUNT',
  PATIENT_MATCHED_COUNT: 'PATIENT_MATCHED_COUNT',
  PATIENT_COUNT: 'PATIENT_COUNT',
  PATIENT_ENROLLED_COUNT: 'PATIENT_ENROLLED_COUNT',
  PATIENT_IN_PRE_SCREENING_COUNT: 'PATIENT_IN_PRE_SCREENING_COUNT',
  PATIENT_IN_REVIEW_COUNT: 'PATIENT_IN_REVIEW_COUNT',
  PATIENT_NOT_CONSENTED_COUNT: 'PATIENT_NOT_CONSENTED_COUNT',
  PATIENT_NOT_ELIGIBLE_COUNT: 'PATIENT_NOT_ELIGIBLE_COUNT',
  PLANNED_ENROLLMENT_TO_DATE: 'PLANNED_ENROLLMENT_TO_DATE',
  PROJECTED_TOTAL_DURATION: 'PROJECTED_TOTAL_DURATION',
  PROJECTED_TOTAL_ENROLLMENT: 'PROJECTED_TOTAL_ENROLLMENT',
  SPONSOR_NAME: 'SPONSOR_NAME',
  TARGET_DURATION: 'TARGET_DURATION',
  TARGET_ENROLLMENT: 'TARGET_ENROLLMENT',
  TARGET_MONTHLY_ENROLLMENT: 'TARGET_MONTHLY_ENROLLMENT',
  TREND_DATE: 'TREND_DATE',
  TRIAL_CONTRACTED: 'TRIAL_CONTRACTED',
  TRIAL_SUMMARY_TYPE: 'TRIAL_SUMMARY_TYPE',
  TRIAL_EXTERNAL_ID: 'TRIAL_EXTERNAL_ID',
  TRIAL_FRIENDLY_NAME: 'TRIAL_FRIENDLY_NAME',
  TRIAL_ID: 'TRIAL_ID',
  TRIAL_LINK: 'TRIAL_LINK',
  TRIAL_PRIMARY_COMPLETION_DATE: 'TRIAL_PRIMARY_COMPLETION_DATE',
  TRIAL_START_DATE: 'TRIAL_START_DATE',
  ORGANIZATION_PARENT_TRIAL_EXTERNAL_ID: 'ORGANIZATION_PARENT_TRIAL_EXTERNAL_ID',
  OVERALL_TRIAL_STATUS: 'OVERALL_TRIAL_STATUS',
  ORGANIZATION_ID: 'ORGANIZATION_ID',
  ORGANIZATION_NAME: 'ORGANIZATION_NAME',
  ORGANIZATION_REGION: 'ORGANIZATION_REGION',
  ORGANIZATION_NAME_OVERRIDE: 'ORGANIZATION_NAME_OVERRIDE',
  ORGANIZATION_FRIENDLY_NAME: 'ORGANIZATION_FRIENDLY_NAME',
  ORGANIZATION_EXTERNAL_ID: 'ORGANIZATION_EXTERNAL_ID',
  ORGANIZATION_RECRUITING_END_DATE: 'ORGANIZATION_RECRUITING_END_DATE',
  ORGANIZATION_RECRUITING_START_DATE: 'ORGANIZATION_RECRUITING_START_DATE',
  ORGANIZATION_SPONSOR_ID: 'ORGANIZATION_SPONSOR_ID',
  ORGANIZATION_TRIAL_CARE_TEAM: 'ORGANIZATION_TRIAL_CARE_TEAM',
  ORGANIZATION_TRIAL_ID: 'ORGANIZATION_TRIAL_ID',
  ORGANIZATION_TRIAL_STATUS: 'ORGANIZATION_TRIAL_STATUS',
  ORGANIZATION_TRIAL_IS_ANONYMOUS: 'ORGANIZATION_TRIAL_IS_ANONYMOUS',
  ORGANIZATION_TRIAL_ANONYMOUS_ID: 'ORGANIZATION_TRIAL_ANONYMOUS_ID',
  ORGANIZATION_PARENT_TRIAL_STATUS: 'ORGANIZATION_PARENT_TRIAL_STATUS'
}
